'use client'

import DiscordIcon from '@/components/icons/logos/discord'
import Link from 'next/link'

export default function DiscordBotCTA() {
  return (
    <Link
      href="/discord-bot"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-linear-to-r mb-4 flex h-[52px] items-center justify-center gap-2 rounded-sm from-[#525CD6] to-[#2E2F7D] px-4 py-2 text-shades-0 transition-all duration-150 hover:scale-105 hover:opacity-90"
    >
      <DiscordIcon className="w-5 fill-white" />
      <span className="font-medium">Get the Discord Bot</span>
    </Link>
  )
}
